import React, { Component } from "react";
import {
  Select,
  Spin,
  Empty,
  DatePicker,
  Input,
  Button,
  Tooltip,
} from "antd";
import Select2 from "../select2/index";
import Select2multiple from "../select2/multiple";
import { times } from "ramda";
import { DeleteOutlined} from '@ant-design/icons';

// import InputNumberlayer from './../../components/FormComponent/InputNumberlayer';

const { Option } = Select;

class Tableantd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      table_head: [],
      table_body: [],
      add_more: false,
      add_more_title: null,
      Queuedata: [],
    };
  }

  componentDidMount() {
    let { table_head, table_body, add_more, add_more_title } =
      this.props.table_data;
    this.setState({
      table_head: table_head,
      table_body: table_body,
      add_more: add_more,
      add_more_title: add_more_title,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    let { table_body } = this.state;
    // console.log('update:', this.state.table_body.length, prevProps.table_data.table_body.length, this.props.table_data.table_body.length)
    if (
      prevProps.table_data.table_body.length > 0 &&
      this.state.table_body.length > 0
    ) {
      if (
        prevProps.table_data.table_body[0].feilds.length > 0 &&
        this.state.table_body[0].feilds.length > 0
      ) {
        if (
          prevProps.table_data.table_body[0].feilds[0].value !==
          this.state.table_body[0].feilds[0].value
        ) {
          this.setState(
            (state) => ({ table_body: this.props.table_data.table_body }),
            () => {
              this.props.table_body_change(this.props.table_data.table_body);
            }
          );
        }
      }
    }
  }

  handleChange(data) {
    // console.log(data);
    this.props.change(data);
  }

  addButton() {
    let add_more_feilds = this.props.table_data.add_more_feilds;
    let { table_body } = this.state;

    let add_more = JSON.parse(JSON.stringify(add_more_feilds));

    add_more.map((feild, key) => {
      add_more[key]["id"] = table_body.length + 1;
      add_more[key]["value"] = null;
      add_more[key]["text"] = null;
    });

    let obj = {
      id: table_body.length + 1,
      text: "Highend",
      type: "text",
      input_feild: [],
      feilds: add_more,
    };

    this.setState(
      (state) => ({ table_body: state.table_body.concat(obj) }),
      () => {
        let { table_body } = this.state;
        this.props.table_body_change(table_body);
      }
    );
  }

  deleteRow(row_id) {
    let table_body = this.state.table_body;
    if (table_body.length>1) {
      table_body.splice(row_id, 1);
      this.setState(
        (state) => ({ table_body: table_body }),
        () => {
          let { table_body } = this.state;
          this.props.table_body_change(table_body);
        }
      );
    }
  }
  selectChanges(feild, event) {
    if (event.name === "service_group") {
      let { table_body } = this.state;
      table_body.map((data, data_key) => {
        if (data.id === feild.id) {
          table_body[data_key]["service_group"] = event.value;
        }
      });
      this.setState((state) => ({ table_body: table_body }));
    }
    this.setState((state) => ({ changedObj: event }));
    this.props.onChange(event);

    // console.log('antd Queuedata', this.props.Queuedata)
  }
  render() {
    let { table_head, table_body, add_more, add_more_title } = this.state;
    let { slug } = this.props.match.params;
    return (
      <table className="table border">
        <thead>
          <tr>
            {table_head.map((head, hKey) => {
              return (
                <td style={{ width: head.width }} key={hKey}>
                  {head.text}
                </td>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {table_body.map((feild, key) => {
            return (
              <tr key={key}>
                <td>{key + 1}</td>

                {feild.feilds.map((input, inkey) => {
                  if (input.visible && input.element === "input") {
                    return (
                      <td key={inkey}>
                        <div className="">
                          {/* <InputNumberlayer {...this.props} {...this.state} selectdata={input} onInputChanges={this.handleChange.bind(this)}/>                                                    */}
                        </div>
                      </td>
                    );
                  }
                  if (input.visible && input.element === "select") {
                    if (input.readonly) {
                      return (
                        <td class="my-4">
                          <div>
                            <p className="form-control mb-0 readonly">
                              {input.text}
                            </p>
                          </div>
                        </td>
                      );
                    } else {
                      return (
                        <td key={inkey}>
                          <div className="row mx-0">
                            <div className="col px-0">
                              <Select2
                                key={input.name}
                                selectdata={input}
                                {...this.props}
                                {...this.state}
                                Queuedata={feild.feilds}
                                onselectChanges={this.selectChanges.bind(
                                  this,
                                  feild
                                )}
                              />
                              {input.errors.map((err, key) => {
                                return (
                                  <small className="text-danger" key={key}>
                                    {err.message}
                                  </small>
                                );
                              })}
                            </div>
                          </div>
                        </td>
                      );
                    }
                  }
                  if (input.visible && input.element === "select2multiple") {
                    if (input.readonly) {
                      return (
                        <td class="my-4">
                          <div>
                            <p className="form-control mb-0 readonly">
                              {input.text}
                            </p>
                          </div>
                        </td>
                      );
                    } else {
                      return (
                        <td key={inkey}>
                          <div className="row mx-0">
                            <div className="col px-0">
                              <Select2multiple
                                Queuedata={this.props.Queuedata}
                                selectdata={input}
                                row_feild={feild}
                                row_key={key}
                                {...this.props}
                                {...this.state}
                                onselectChanges={this.selectChanges.bind(
                                  this,
                                  feild
                                )}
                              />
                              {input.errors.map((err, key) => {
                                return (
                                  <small className="text-danger" key={key}>
                                    {err.message}
                                  </small>
                                );
                              })}
                            </div>
                          </div>
                        </td>
                      );
                    }
                  }
                  if (input.visible && input.element === "action") {
                    return (
                      <td key={inkey} className="text-center">
                        {slug === "view" ? (
                          "--"
                        ) : (
                          <Tooltip title="Remove">
                            {/* <Icon
                              type="delete"
                              style={{ color: "red" }}
                              onClick={this.deleteRow.bind(this, key)}
                            /> */}
                            <DeleteOutlined style={{ color: 'red' }} onClick={() => this.deleteRow(key)} />
                          </Tooltip>
                        )}
                      </td>
                    );
                  }
                  if (input.visible && input.element === "text") {
                    return (
                      <td
                        key={inkey}
                        colSpan={input.colSpan}
                        className="text-center"
                      >
                        {input.title}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
          {slug !== "view" && (
            <React.Fragment>
              {add_more && (
                <tr>
                  <td colSpan={table_head.length} className="text-right">
                    <button
                      type="button"
                      className="btn btn-magenta"
                      onClick={() => this.addButton(this)}
                    >
                      {add_more_title}
                    </button>
                  </td>
                </tr>
              )}
            </React.Fragment>
          )}
        </tbody>
      </table>
    );
  }
}

export default Tableantd;
